import { createApp } from 'vue'
import Gizlilik from './Gizlilik.vue'
import './assets/global.css'

createApp(Gizlilik).mount('#gizlilik')
